import { render } from "./TodosList.vue?vue&type=template&id=136b437c&scoped=true"
import script from "./TodosList.vue?vue&type=script&lang=js"
export * from "./TodosList.vue?vue&type=script&lang=js"

import "./TodosList.vue?vue&type=style&index=0&id=136b437c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-136b437c"]])

export default __exports__